module.exports = __webpack_public_path__ + "assets/img/ph_d_1.7d16654f.jpg";